import React from 'react';
import {classes, style} from './doppe-background-view.st.css';
import {
    evaluateFunction,
    HtmlObjectHorizontalPosition,
    HtmlObjectResizeMode,
    HtmlObjectVerticalPosition
} from '@wix/devzai-utils-common';
import {WixImageView} from '@wix/devzai-common-client';
import {ImageViewPositionHorizontal, ImageViewPositionVertical, ImageViewResizeMode} from '@wix/devzai-utils-react';
import {
    WixMediaResource,
    wixMediaResourceIsWixImageResource,
    WixVideoInfoQualitySelector
} from '@wix/devzai-common-wix';
import {doppePageBackgroundViewGetInitialSource} from '../doppe-page-background-view/doppe-page-background-view';
import {
    DoppePageDefaultImageView,
    DoppePageDefaultImageViewImage
} from "../doppe-page-default-image-view/doppe-page-default-image-view";
import {DoppePageVideoMediaView} from "../doppe-page-video-media-view/doppe-page-video-media-view";

export const DoppeBackgroundView = React.memo(function DoppeBackgroundView(props: DoppeBackgroundView.Props) {
    const {
        className,
        heroPhoto = null,
        opacity,
        verticalPosition,
        horizontalPosition,
        ...htmlAttributes
    } = props;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            {evaluateFunction(() => {

                if (heroPhoto === null) {
                    return (
                        <DoppePageDefaultImageView
                            className={style(classes.backgroundImage, {})}
                            image={DoppePageDefaultImageViewImage.FullPageImage}
                        />
                    )
                } else if (wixMediaResourceIsWixImageResource(heroPhoto)) {
                    return (
                        <WixImageView
                            className={style(classes.backgroundImage, {})}
                            src={heroPhoto}
                            resizeMode={ImageViewResizeMode.Cover}
                            positionVertical={verticalPosition ?? ImageViewPositionVertical.Center}
                            positionHorizontal={horizontalPosition ?? ImageViewPositionHorizontal.Center}
                            placeholderSrc={doppePageBackgroundViewGetInitialSource}
                            style={{
                                opacity: opacity !== undefined ? opacity / 100 : 1
                            }}
                        />
                    )
                } else {
                    return (
                        <>
                            {heroPhoto.poster ? (
                                <WixImageView
                                    className={style(classes.videoMediaPoster, {})}
                                    src={heroPhoto.poster}
                                    resizeMode={ImageViewResizeMode.Cover}
                                    positionVertical={HtmlObjectVerticalPosition.Center}
                                    positionHorizontal={HtmlObjectHorizontalPosition.Center}
                                    placeholderSrc={doppePageBackgroundViewGetInitialSource}
                                    style={{
                                        opacity: opacity ? opacity / 100 : 1
                                    }}
                                />
                            ) : null}
                            <DoppePageVideoMediaView
                                className={style(classes.backgroundImage, {})}
                                resizeMode={HtmlObjectResizeMode.Cover}
                                quality={WixVideoInfoQualitySelector.Highest}
                                positionVertical={HtmlObjectVerticalPosition.Center}
                                positionHorizontal={HtmlObjectHorizontalPosition.Center}
                                src={heroPhoto}
                                autoPlay={true}
                                loop={true}
                                muted={true}
                                playsInline={true}
                                style={{
                                    opacity: opacity ? opacity / 100 : 1
                                }}
                            />
                        </>
                    );
                }
            })}
        </div>
    );
});

export namespace DoppeBackgroundView {

    export interface Props extends React.HTMLAttributes<any> {
        heroPhoto?: WixMediaResource;
        opacity?: number;
        horizontalPosition?: HtmlObjectHorizontalPosition;
        verticalPosition?: HtmlObjectVerticalPosition;
    }
}

